import React from 'react'
import PropTypes from 'prop-types'
import { EventGroup } from '../../../datastores/eventGroup'

export function Header({ eventGroup }) {
  return (
    <div className='participants-modal-header'>
      <div className='participants-modal-header__image object-fit'>
        <img src={eventGroup.featured_image} alt='' />
      </div>
      <div className='participants-modal-header__text'>
        <div className='participants-modal-header__tagline'>
          Positiv psykologi | Uddannelse {/*todo: find out where these tags come from*/}
        </div>
        <div className='participants-modal-header__title'>
          {eventGroup.title}
        </div>
        <div className='participants-modal-header__subtitle'>
          {eventGroup.subtitle}
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  eventGroup: PropTypes.instanceOf(EventGroup)
}
